import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const SubtractFill = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    title="SubtractFill"
    {...props}
  >
    <path d="M19 11H5V13H19V11Z" />
  </svg>
);
export default React.memo(SubtractFill);
